'use client';

/**
 * SiteBlogCta — 현장 상세 하단 고정 바의 블로그 유입 버튼(blog-btn · 종전 「실시간 소통」 카톡방 버튼 자리 · Node 지시).
 *   목적지·문구는 서버(lib/inflow/site-blog-cta)가 정한다. 여기는 계측(노출·클릭)만 — 기존 CTA 수집 경로(/api/events/cta)
 *   cta_name·category 'site_blog_btn'. SSR 마크업은 정적 <a href> 라 JS 없이도 동작하고 모든 UA 에 같은 HTML.
 *   머리말(.bb-pre)은 좁은 화면에서 버튼이 둘일 때 CSS 로만 접는다(detail-ds2.css).
 */
import { useEffect, useRef } from 'react';
import { trackCtaClick, trackCtaView } from '@/lib/cta-track';
import type { SiteBlogCta as SiteBlogCtaData } from '@/lib/inflow/site-blog-cta';
import './cl.css';

export const SITE_BLOG_CTA_NAME = 'site_blog_btn';

export default function SiteBlogCta({ cta }: { cta: SiteBlogCtaData }) {
  const ref = useRef<HTMLAnchorElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === 'undefined') return;
    const io = new IntersectionObserver((es) => {
      if (es.some((e) => e.isIntersecting)) {
        trackCtaView({ cta_name: SITE_BLOG_CTA_NAME, category: SITE_BLOG_CTA_NAME });
        io.disconnect();
      }
    }, { threshold: 0.5 });
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return (
    <a
      ref={ref}
      className="cl-talk cl-blogbtn"
      href={cta.href}
      onClick={() => trackCtaClick({ cta_name: SITE_BLOG_CTA_NAME, category: SITE_BLOG_CTA_NAME })}
      data-cl-cta="blog"
      data-blog-scope={cta.scope}
    >
      <span className="bb-pre">{cta.prefix}</span>
      {cta.label}
    </a>
  );
}
